import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Row,
  Card,
  CardBody,
  Input,
  CardHeader,
  Table,
  ModalHeader,
  ModalBody,
  Modal,
  Progress,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";

import { useLocation, useParams } from "react-router-dom";
import classnames from "classnames";
const PEARLS = (props) => {
  // const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const [isEditing, setIsEditing] = useState(false);

  const [activeTab, setactiveTab] = useState(1);
  const [passedSteps, setPassedSteps] = useState([1]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [progressbarvalue, setprogressbarvalue] = useState(0);
  const openModal = () => {
    setIsModalOpen(true);
  };

  function toggleTab(tab, value) {
    if (activeTab !== tab) {
      var modifiedSteps = [...passedSteps, tab];

      if (tab >= 1 && tab <= 4) {
        setactiveTab(tab);
        setPassedSteps(modifiedSteps);
      }
    }
    setprogressbarvalue(value);
  }

  const handleDownload = () => {
    alert("Downloading PEARLS...");
  };

  return (
    <div className="page-content">
      <Container>
        <Card>
          <CardBody>
            <div className="d-flex gap-2 text-end justify-content-end">
              <div className="d-flex justify-content-center justify-content-md-end mb-3">
                <Button color="success" onClick={handleDownload}>
                  Download
                </Button>
              </div>
            </div>
            <CardHeader style={{ fontWeight: "bold" }}>
              <p className="text-center">नमुना बचत तथा ऋण सहकारी संस्था लि.</p>
              <p className="text-center">सुनपा ४, धादिकोट</p>
              <p className="text-center">पर्ल्स अनुपात</p>
            </CardHeader>
            <table className="table table-bordered table-stripped responsive">
              <thead>
                <tr className="secondary">
                  <th className="text-start">शुचक</th>
                  <th className="text-start">क्षेत्र</th>
                  <th className="text-start">विवरण</th>
                  <th className="text-start">रकम</th>
                  <th className="text-start">लेखमा</th>
                  <th className="text-start">मापदण्ड</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td
                    rowSpan="3"
                    style={{ fontWeight: "bold" }}
                    className="text-start"
                  >
                    P-Protection<div>(सुरक्षा)</div>
                  </td>
                  <td style={{ fontWeight: "bold" }} className="text-start">
                    P1
                  </td>

                  <td>
                    <p className="text-start">नुक्सानको लागि बेवस्था</p>
                    <p className="text-start">खराब कर्जा</p>
                  </td>
                  <td>
                    <p className="text-end">129,927,414.08</p>
                    <p className="text-end">129,927,414.08</p>
                  </td>

                  <td>
                    <p>0.0%</p>
                  </td>
                  <td>
                    <p>0.0%</p>
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold" }}>P2</td>
                  <td>
                    <p className="text-start">नुक्सानको लागि बेवस्था</p>
                    <p className="text-start">संख्याशास्त्रिक कर्जा</p>
                  </td>

                  <td>
                    <p className="text-end">129,927,414.08</p>
                    <p className="text-end">129,927,414.08</p>
                  </td>
                  <td>
                    <p>50.0%</p>
                  </td>
                  <td>
                    <p>30.0%</p>
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold" }}>P3</td>
                  <td>
                    <p className="text-start">सक्रिय कर्जा</p>
                    <p className="text-start">खुला कर्जा</p>
                  </td>
                  <td>
                    <p className="text-end">129,927,414.08</p>
                    <p className="text-end">129,927,414.08</p>
                  </td>

                  <td>
                    <p>60%</p>
                  </td>
                  <td>
                    <p>70.0%</p>
                  </td>
                </tr>

                <tr>
                  <td
                    rowSpan="5"
                    style={{ fontWeight: "bold" }}
                    className="text-start"
                  >
                    E-Effective Financial Structure{" "}
                    <div>(अभिकर्मी वित्तीय संरचना)</div>
                  </td>
                  <td style={{ fontWeight: "bold" }}>E1</td>
                  <td>
                    <p className="text-start">कुल कर्जा</p>
                    <p className="text-start">कुल सम्पत्ति</p>
                  </td>
                  <td>
                    <p className="text-end">129,927,414.08</p>
                    <p className="text-end">129,927,414.08</p>
                  </td>

                  <td>0.0%</td>
                  <td>0.0%</td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold" }}>E3</td>
                  <td>
                    <p className="text-start">बितिया लगानी</p>
                    <p className="text-start">कुल सम्पत्ति</p>
                  </td>
                  <td>
                    <p className="text-end">129,927,414.08</p>
                    <p className="text-end">129,927,414.08</p>
                  </td>
                  <td>50.0%</td>
                  <td>30.0%</td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold" }}>E5</td>
                  <td>
                    <p className="text-start">बचत</p>
                    <p className="text-start">कुल सम्पत्ति</p>
                  </td>
                  <td>
                    <p className="text-end">129,927,414.08</p>
                    <p className="text-end">129,927,414.08</p>
                  </td>
                  <td>60%</td>
                  <td>70.0%</td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold" }}>E7</td>
                  <td>
                    <p className="text-start">शेयर पुँजी</p>
                    <p className="text-start">कुल सम्पत्ति</p>
                  </td>
                  <td>
                    <p className="text-end">129,927,414.08</p>
                    <p className="text-end">129,927,414.08</p>
                  </td>
                  <td>0.0%</td>
                  <td>0.0%</td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold" }}>E8</td>
                  <td>
                    <p className="text-start">संस्थागत पुँजी</p>
                    <p className="text-start">कुल सम्पत्ति</p>
                  </td>
                  <td>
                    <p className="text-end">129,927,414.08</p>
                    <p className="text-end">129,927,414.08</p>
                  </td>
                  <td>50.0%</td>
                  <td>30.0%</td>
                </tr>

                <tr>
                  <td
                    rowSpan="3"
                    style={{ fontWeight: "bold" }}
                    className="text-start"
                  >
                    A-Assets Quality <div>(सम्पत्ति गुणस्तर)</div>
                  </td>
                  <td style={{ fontWeight: "bold" }}>A1</td>
                  <td>
                    <p className="text-start">भक्का नानागेको कर्जा</p>
                    <p className="text-start">कुल कर्जा</p>
                  </td>
                  <td className="text-end">129,927,414.08</td>
                  <td>0.0%</td>
                  <td>0.0%</td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold" }}>A2</td>
                  <td>
                    <p className="text-start">आए नहुने सम्पत्ति</p>
                    <p className="text-start">कुल सम्पत्ति</p>
                  </td>
                  <td className="text-end">129,927,414.08</td>
                  <td>50.0%</td>
                  <td>30.0%</td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold" }}>A3</td>
                  <td>
                    <p className="text-start">बिना लगातको पुँजी</p>
                    <p className="text-start">आए नहुने सम्पत्ति</p>
                  </td>
                  <td className="text-end">129,927,414.08</td>
                  <td>60%</td>
                  <td>70.0%</td>
                </tr>
                <tr>
                  <td
                    rowSpan="7"
                    style={{ fontWeight: "bold" }}
                    className="text-start"
                  >
                    R-Rates of Returns and Cost <div>(प्रतिफल दर)</div>
                  </td>
                  <td style={{ fontWeight: "bold" }}>R1</td>
                  <td>
                    <p className="text-start">कर्जबाद खुद आय</p>
                    <p className="text-start">औसत कर्जा</p>
                  </td>
                  <td className="text-end">129,927,414.08</td>
                  <td>0.0%</td>
                  <td>0.0%</td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold" }}>R3</td>
                  <td>
                    <p className="text-start">बिबिताय लगानीबाद आय</p>
                    <p className="text-start">औसत वितिय लगानी</p>
                  </td>
                  <td className="text-end">129,927,414.08</td>
                  <td>50.0%</td>
                  <td>30.0%</td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold" }}>R5</td>
                  <td>
                    <p className="text-start">बचतमा ब्याज</p>
                    <p className="text-start">औसत बचत</p>
                  </td>
                  <td className="text-end">129,927,414.08</td>
                  <td>60%</td>
                  <td>70.0%</td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold" }}>R7</td>
                  <td>
                    <p className="text-start">शेयर पुँजिमा लाभान्वित</p>
                    <p className="text-start">औसत शेयर पुँजिमा</p>
                  </td>
                  <td className="text-end">129,927,414.08</td>
                  <td>0.0%</td>
                  <td>0.0%</td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold" }}>R8</td>
                  <td>
                    <p className="text-start">कुल मुनाफा</p>
                    <p className="text-start">औसत सम्पत्ति</p>
                  </td>
                  <td className="text-end">129,927,414.08</td>
                  <td>50.0%</td>
                  <td>30.0%</td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold" }}>R9</td>
                  <td>
                    <p className="text-start">खुद आय</p>
                    <p className="text-start">औसत सम्पत्ति</p>
                  </td>
                  <td className="text-end">129,927,414.08</td>
                  <td>50.0%</td>
                  <td>30.0%</td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold" }}>R12</td>
                  <td>
                    <p className="text-start">प्रशासनिक खर्च</p>
                    <p className="text-start">औसत सम्पत्ति</p>
                  </td>
                  <td className="text-end">129,927,414.08</td>
                  <td className="text-end">50.0%</td>
                  <td className="text-end">30.0%</td>
                </tr>

                <tr>
                  <td
                    rowSpan="3"
                    style={{ fontWeight: "bold" }}
                    className="text-start"
                  >
                    L-Liquidity<div>(तरलता)</div>
                  </td>
                  <td style={{ fontWeight: "bold" }}>L1</td>

                  <td>
                    <p className="text-start">तरल सम्पत्ति</p>
                    <p className="text-start">कुल बचत</p>
                  </td>
                  <td>
                    <p className="text-end">129,927,414.08</p>
                    <p className="text-end">129,927,414.08</p>
                  </td>

                  <td>
                    <p>0.0%</p>
                  </td>
                  <td>
                    <p>0.0%</p>
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold" }}>L2</td>
                  <td>
                    <p className="text-start">नगद मौजूद</p>
                    <p className="text-start">कुल सम्पत्ति</p>
                  </td>

                  <td>
                    <p className="text-end">129,927,414.08</p>
                    <p className="text-end">129,927,414.08</p>
                  </td>
                  <td>
                    <p>50.0%</p>
                  </td>
                  <td>
                    <p>30.0%</p>
                  </td>
                </tr>

                {/* <tr>
                <td style={{ fontWeight: "bold" }}>
                  S-Signs of Growth<div>(वार्षिक वृद्धि संकेत)</div>
                </td>
                <td style={{ fontWeight: "bold" }}>S10</td>
                <td>
                  <p>शेयर सदस्य संख्यामा वृद्धि</p>
                  <p>कुल सम्पत्तिमा वृद्धि</p>
                </td>
                <td>
                  <p>129,927,414.08</p>
                  <p>129,927,414.08</p>
                </td>
                <td>
                  <p>0.0%</p>
                </td>
              </tr>
              <tr>
                <td style={{ fontWeight: "bold" }}>S11</td>
                <td>
                  <p>नगद मौजूद</p>
                  <p>कुल सम्पत्ति</p>
                </td>
                <td>
                  <p>129,927,414.08</p>
                  <p>129,927,414.08</p>
                </td>
                <td>
                  <p>50.0%</p>
                </td>
                <td>
                  <p>30.0%</p>
                </td>
              </tr> */}
              </tbody>
            </table>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default PEARLS;
